import { useCallback, useEffect, useRef } from 'react';

export function useAdsgram({ blockId, onReward, onError }) {
	const AdControllerRef = useRef(undefined);

	useEffect(() => {
		if (window.Adsgram?.init) {
			AdControllerRef.current = window.Adsgram.init({ blockId });
		}
	}, [blockId]);

	return useCallback(async () => {
		if (AdControllerRef.current) {
			AdControllerRef.current
				.show()
				.then(() => {
					onReward();
				})
				.catch((result) => {
					onError?.(result);
				});
		} else {
			onError?.({
				error: true,
				done: false,
				state: 'load',
				description: 'Adsgram script not loaded',
			});
		}
	}, [onError, onReward]);
} 